import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface CategoryTab {
  key: string;
  label: string;
  icon: string;
  count?: number;
}

@Component({
  selector: 'app-mobile-category-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-category-tabs.component.html',
  styleUrls: ['./mobile-category-tabs.component.css'],
})
export class MobileCategoryTabsComponent implements OnChanges {
  @Input() tabs: CategoryTab[] = [];
  @Input() activeKey = '';
  @Output() tabChange = new EventEmitter<string>();

  pillWidth = '25%';
  pillOffset = 0;

  ngOnChanges(): void {
    this.updatePill();
  }

  private touchHandled = false;

  private markTouchHandled(): void {
    this.touchHandled = true;
    setTimeout(() => (this.touchHandled = false), 400);
  }

  selectTabClick(key: string): void {
    if (this.touchHandled) return;
    this.tabChange.emit(key);
  }

  selectTabTouch(key: string, event: TouchEvent): void {
    event.preventDefault();
    this.markTouchHandled();
    this.tabChange.emit(key);
  }

  private updatePill(): void {
    const count = this.tabs.length || 1;
    this.pillWidth = (100 / count) + '%';
    const idx = this.tabs.findIndex(t => t.key === this.activeKey);
    this.pillOffset = (idx >= 0 ? idx : 0) * 100;
  }
}
